import axios from 'axios'
import {Loading} from 'element-ui';
import {MessageBox, Message} from 'element-ui'

let common = {
  /**
   *导出Excel
   * @param url 接口地址
   * @param data 参数
   * @param methods 请求方式
   * @param fileName 文件名称
   */
  exportExcel: function (url, data, methods, fileName) {
    const loading = Loading.service({
      lock: true,
      text: '加载中,请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    });
    axios({
      method: (methods ? methods.toUpperCase() : 'GET'),
      url: url,
      responseType: 'blob',
      headers: {
        'token': sessionStorage.getItem('token')
      },
      data: data || {}
    }).then(res => {
      const resData = res.data
      const fileReader = new FileReader()
      fileReader.onloadend = () => {
        if (resData.type === 'application/json') {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          // 后台信息
          Message({
            message: jsonData.msg || 'Error',
            type: 'error',
            duration: 3000
          });
        } else {
          // 下载文件
          const link = document.createElement('a')
          let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = fileName + '.xls' //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
      fileReader.readAsText(resData)
      loading.close();
    })
  },
  /**
   *导出PDF
   * @param url 接口地址
   * @param data 参数
   * @param methods 请求方式
   * @param fileName 文件名称
   */
  downloadPdf: function (url, data, methods, fileName) {
    const loading = Loading.service({
      lock: true,
      text: '加载中,请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    });
    axios({
      method: (methods ? methods.toUpperCase() : 'GET'),
      url: url,
      responseType: 'blob',
      headers: {
        'token': sessionStorage.getItem('token')
      },
      data: data || {}
    }).then(res => {
      const resData = res.data
      const fileReader = new FileReader()
      fileReader.onloadend = () => {
        if (resData.type === 'application/json') {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          // 后台信息
          Message({
            message: jsonData.msg || 'Error',
            type: 'error',
            duration: 3000
          });
        } else {
          // 下载文件
          const link = document.createElement('a')
          let blob = new Blob([res.data], {type: 'application/pdf'})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = fileName + '.pdf' //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
      fileReader.readAsText(resData)
      loading.close();
    })
  },
  /**
   *下载zip
   * @param url 接口地址
   * @param data 参数
   * @param methods 请求方式
   * @param fileName 文件名称
   */
  downloadZip: function (url, data, methods, fileName) {
    const loading = Loading.service({
      lock: true,
      text: '加载中,请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    });
    axios({
      method: (methods ? methods.toUpperCase() : 'GET'),
      url: url,
      responseType: 'blob',
      headers: {
        'token': sessionStorage.getItem('token')
      },
      data: data || {}
    }).then(res => {
      const resData = res.data
      const fileReader = new FileReader()
      fileReader.onloadend = () => {
        if (resData.type === 'application/json') {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          // 后台信息
          Message({
            message: jsonData.msg || 'Error',
            type: 'error',
            duration: 3000
          });
        } else {
          // 下载文件
          const link = document.createElement('a')
          let blob = new Blob([res.data], {type: 'application/zip'})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = fileName + '.zip' //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
      fileReader.readAsText(resData)
      loading.close();
    })
  },
    /**
   *下载img
   * @param url 接口地址
   * @param data 参数
   * @param methods 请求方式
   * @param fileName 文件名称
   */
   newDownload: function (url, data, methods,callback,fileName1) {
    const loading = Loading.service({
      lock: true,
      text: '加载中,请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    });

    let obj = {

    }
    if(methods == 'GET' || methods == 'get' ){
      obj.params = data
    }

    if(methods == 'POST' || methods == 'post' ){
      obj.data = data
    }

    axios({
      method: (methods ? methods.toUpperCase() : 'GET'),
      url: url,
      responseType: 'blob',
      headers: {
        'token': sessionStorage.getItem('token')
      },
      // params: data || {},
      // data: data || {}
      ...obj
    }).then(res => {
      const resData = res.data
      // let fileName = decodeURI(res.headers['content-disposition'].split('\'\'')[1])
      let fileName = res.headers["content-disposition"].split("=");
      fileName = fileName[fileName.length - 1];
      fileName =decodeURI(fileName.replace(/"/g, "")) ;

      const fileReader = new FileReader()
      fileReader.onloadend = () => {
          // 下载文件
          const link = document.createElement('a')
          let blob = new Blob([res.data], {type: res.headers['content-type']})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = fileName1 || fileName //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
      }
      fileReader.readAsText(resData)
      loading.close();

      callback && callback()
    })
  },
  /**
   * 下载文件【可以下载图片】 将网络地址转换为文件流进行下载
   * @param url 路径
   * @param fileName 文件名称
   */
  downloadFiles: function (url, fileName) {
    const loading = Loading.service({
      lock: true,
      text: '加载中,请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    });
    return axios({
      method: 'get',
      url: url,
      // responseType: 'blob'
      responseType: 'arraybuffer'

    }).then(res => {
      loading.close();
      const {data, headers} = res
      const blob = new Blob([data], {type: headers['content-type']})
      let dom = document.createElement('a')
      let url = window.URL.createObjectURL(blob)
      dom.href = url
      dom.download = decodeURI(fileName)
      dom.style.display = 'none'
      document.body.appendChild(dom)
      dom.click()
      dom.parentNode.removeChild(dom)
      window.URL.revokeObjectURL(url)
      return res
    })
  },
  /**
   * 下载文件 将网络地址转换为文件流进行下载
   * @param url 路径
   * @param fileName 文件名称
   */
  downloadFile: function (url, fileName) {
    const loading = Loading.service({
      lock: true,
      text: '加载中,请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    });
    return axios({
      method: 'get',
      url: url,
      responseType: 'blob'
    }).then(res => {
      loading.close();
      const {data, headers} = res
      var blob = new Blob([data]);
      var url = window.URL.createObjectURL(blob);
      var aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = url;
      aLink.setAttribute("download", fileName);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink); //下载完成移除元素
      window.URL.revokeObjectURL(url); //释放掉blob对象
      return res
    })
  },
  /**
   *数组去重
   * @param oldArr 数组
   * @param keyword 关键字
   * @returns {*}
   */
  uniqueFun: function uniqueFun(oldArr, keyword) {
    for (let i = 0; i < oldArr.length; i++) {
      for (let j = i + 1; j < oldArr.length;) {
        if (oldArr[i][keyword] == oldArr[j][keyword]) { //此处是你要判断的值
          oldArr.splice(j, 1)//去除重复的对象；
          break
        } else {
          j++
        }
      }
    }
    return oldArr
  },
  /**
   * 单纯的数组去重
   * @param arr
   * @returns {*}
   */
  unique(arr) {
    const res = new Map();
    return arr.filter((arr) => !res.has(arr) && res.set(arr, 1))
  },
  /**
   * 两个数组去重
   * @param arr1 数组1
   * @param arr2 数组2
   * @returns {*}
   */
  mergeArray: function (arr1, arr2) {
    for (let i = 0; i < arr1.length; i++) {
      for (let j = 0; j < arr2.length; j++) {
        if (arr1[i] === arr2[j]) {
          arr1.splice(i, 1) //利用splice函数删除元素，从第i个位置，截取长度为1的元素
        }
      }
    }
    for (let i = 0; i < arr2.length; i++) {
      arr1.push(arr2[i])
    }
    return arr1
  },

  /**
   * 判断数组中的值是否等于同一个值 如果是返回true  否则false
   * var arr = [0, 0 , 1 , 7];
   * isAllEqual(arr); //false
   * var arr = [0, 0 , 0 , 0];
   * isAllEqual(arr); //true
   * @param array
   * @returns {boolean}
   */
  isAllEqual: function (array) {
    if (array.length > 0) {
      return !array.some(function (value, index) {
        return value !== array[0];
      });
    } else {
      return true;
    }
  },
  /**
   * 判断数组中是否存在相同的值  是 true   否则 false
   * var arr = [1, 3 , 1 , 7];
   * isAllEqual(arr); //false
   * var arr = [1, 2 , 3 , 4];
   * isAllEqual(arr); //true
   * @param array
   * @returns {boolean}
   */
  isHasEqual: function (array) {
    for (var i = 0; i < array.length; i++) {
      for (var j = i + 1; j < array.length; j++) {
        if (array[i] == array[j]) {
          return true;
        }
      }
    }
    return false;
  },
  /**
   *
   * @param type (date:yyyy-MM-dd;time: yyyy-MM-dd HH:mm:ss)
   * @returns {string}
   */
  getNowFormatDate: function (type) {
    let date = new Date()
    let seperator1 = '-'
    let seperator2 = ':'
    let month = date.getMonth() + 1
    let strDate = date.getDate()
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate
    }
    //时
    let hour = date.getHours()
    hour = hour.toString().length === 2 ? hour : ('0' + hour)
    //分
    let minute = date.getMinutes()
    minute = minute.toString().length === 2 ? minute : ('0' + minute)
    //秒
    let second = date.getSeconds()
    second = second.toString().length === 2 ? second : ('0' + second)
    let currentDate = ''
    switch (type) {
      case 'date':
        currentDate = date.getFullYear() + seperator1 + month + seperator1 + strDate
        break
      case 'time':
        currentDate = date.getFullYear() + seperator1 + month + seperator1 + strDate
          + ' ' + hour + seperator2 + minute
          + seperator2 + second
        break
      default:
        currentDate = date.getFullYear() + seperator1 + month + seperator1 + strDate
          + ' ' + hour + seperator2 + minute
          + seperator2 + second
    }
    return currentDate
  },
  /**
   * 将时间转化为时间戳
   */
  getTimeStamp: {
    /**
     * 当前时间戳
     * @returns {number}  unix时间戳(毫秒)
     * @constructor
     */
    CurTime13: function () {
      let data = new Date().getTime()
      return data
    },
    /**
     * 当前时间戳
     * @returns {number}  unix时间戳(秒)
     * @constructor
     */
    CurTime: function () {
      let data = Date.parse(new Date()) / 1000
      return data
    },
    /**
     * 日期 转换为 Unix时间戳
     * @param string 日期 转换为 Unix时间戳
     * @returns {number} unix时间戳(秒)
     * @constructor
     */
    DateToUnix: function (string) {
      let f = string.split(' ', 2)
      let d = (f[0] ? f[0] : '').split('-', 3)
      let t = (f[1] ? f[1] : '').split(':', 3)
      let data = (new Date(parseInt(d[0], 10) || null, (parseInt(d[1], 10) || 1) - 1, parseInt(d[2], 10) || null, parseInt(t[0], 10) || null, parseInt(t[1], 10) || null, parseInt(t[2], 10) || null)).getTime() / 1000
      return data
    },
    /**
     * 时间戳转换日期
     * @param unixTime 待时间戳(秒)
     * @param isFull 返回完整时间(Y-m-d 或者 Y-m-d H:i:s)
     * @param timeZone 时区
     * @returns {string}
     * @constructor
     */
    UnixToDate: function (unixTime, isFull, timeZone) {
      if (typeof (timeZone) == 'number') {
        unixTime = parseInt(unixTime) + parseInt(timeZone) * 60 * 60
      }
      let time = new Date(unixTime * 1000)
      let ymdhis = ''
      ymdhis += time.getUTCFullYear() + '-'
      ymdhis += (time.getUTCMonth() + 1) + '-'
      ymdhis += time.getUTCDate()
      if (isFull === true) {
        ymdhis += '' + time.getUTCHours() + ':'
        ymdhis += time.getUTCMinutes() + ':'
        ymdhis += time.getUTCSeconds()
      }
      return ymdhis
    }
  },
  /**
   * 将图片地址转为Base64
   * @param imgUrl 图片地址
   * @param callback 回调函数
   */
  getBase64(imgUrl, callback) {
    //一定要设置为let，不然图片不显示
    const image = new Image()
    //解决跨域问题
    image.setAttribute('crossOrigin', 'anonymous')
    const imageUrl = imgUrl
    image.src = imageUrl
    //image.onload为异步加载
    //eslint-disable-next-line no-undef
    image.onload = function () {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      //eslint-disable-next-line no-undef
      context.drawImage(image, 0, 0, image.width, image.height)
      var quality = 0.8
      //这里的dataurl就是base64类型
      //使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      const dataUrl = canvas.toDataURL('image/jpeg', quality)
      callback ? callback(dataUrl) : null//调用回调函数
    }
  },
  /**
   * 数组，对象的值替换成指定字符
   * @param params
   * @param replace
   * @param type 1 数组 2 对象
   */
  setReplaceKey(params, replace, type) {
    var arr = params
    if (type === 1) { //数组
      arr.forEach(item => {
        Object.keys(item).forEach(key => {
          if (item[key] !== 0) {
            item[key] = item[key] || replace
          } else {
            item[key] = item[key]
          }

        })
      })
    } else if (type === 2) {
      Object.keys(arr).forEach(key => {
        if (arr[key] !== 0) {
          arr[key] = arr[key] || replace
        } else {
          arr[key] = arr[key]
        }
      })
    }
    return arr
  },
  /**
   * 求两个数组的交集
   * @param arr1
   * @param arr2
   * @returns {*}
   */
  intersectionArr(arr1, arr2) {
    return arr1.filter(value => new Set(arr2).has(value))
  },
  /**
   * 秒转化为分秒显示
   * @param second
   * @returns {*}
   */
   secondToMinuteSecond(second) {
    return (second||0) == 0 ? 0 : second < 60 ? second+'秒' : second%60 == 0 ? (Math.floor(second/60)+'分') : (Math.floor(second/60)+'分'+second%60+'秒')
  },
}
export default common
